const REQS_COMPRAS = (state, reqs_compras) => {
    state.reqs_compras = reqs_compras;
};

const REQS_COMPRAS_COTIZAR = (state, reqs_compras_cotizar) => {
    state.reqs_compras = reqs_compras_cotizar;
};

export default {
    REQS_COMPRAS,
    REQS_COMPRAS_COTIZAR,
};